<template>
  <v-expansion-panel>
    <v-expansion-panel-header>
      <div class="professor-info">
        <v-avatar size="40" color="green darken-1">
          <span class="white--text text-h6">
            {{ iniciais }}
          </span>
        </v-avatar>

        <div class="flex-grow-1">
          <div class="text-subtitle-1 font-weight-medium text-uppercase">
            {{ professor.nome }}
          </div>
          <v-chip color="">{{ totalGestoes }} gestão(ões)</v-chip>
        </div>

        <div class="d-flex flex-column align-end">
          <v-chip :color="desempenhoGeralColor" text-color="white" class="mb-1">
            Desempenho: {{ desempenhoGeralPercentual }}%
          </v-chip>
          <!-- <v-chip :color="statusColor" text-color="white"> {{ totalGestoes }} Gestão(ões)</v-chip> -->
        </div>
      </div>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <div class="gestoes-container">
        <v-divider class="my-4"></v-divider>

        <!-- Legenda Fixa que segue a rolagem -->
        <div class="legenda-fixa" :class="{ 'legenda-rolagem': isScrolled }">
          <div class="legenda-content">
            <span class="mr-2"><strong>Legenda de Status:</strong></span>
            <v-chip class="mr-1 mb-1" color="green" text-color="white">Lançamento Completo</v-chip>
            <v-chip class="mr-1 mb-1" color="yellow" text-color="black"
              >Lançamento Incompleto</v-chip
            >
            <v-chip class="mr-1 mb-1" color="red" text-color="white">Nenhum Lançamento</v-chip>
          </div>
        </div>

        <h4 class="text-h6 mb-3">Detalhes das Gestões</h4>

        <v-row>
          <v-col v-for="(gestao, index) in itemsParaTabela" :key="index" cols="12">
            <v-card
              class="gestao-card elevation-2 mb-4"
              outlined
              :class="{ 'zebra-even': index % 2 === 0, 'zebra-odd': index % 2 === 1 }"
            >
              <v-card-title class="pb-2">
                <v-row class="mb-2">
                  <v-col cols="12" sm="6" md="3">
                    <v-icon left color="primary">mdi-account-group</v-icon>
                    <span class="text-subtitle-1 word-break-keep">
                      <strong>Turma: </strong>
                      {{ gestao.turma }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-icon left color="primary">mdi-book-open-variant</v-icon>
                    <span class="text-subtitle-1 word-break-keep">
                      <strong>Componente(s) Curricular(es):</strong>
                      {{ gestao.disciplinas }}
                    </span>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-icon left color="primary">mdi-school</v-icon>
                    <span class="text-subtitle-1 word-break-keep">
                      <strong>Etapas: </strong>
                      <v-chip
                        v-for="serie in gestao.series"
                        :key="serie.id"
                        small
                        color="primary"
                        class="mr-1 mb-1"
                      >
                        {{ serie }}
                      </v-chip>
                    </span>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-icon left color="primary">mdi-account-eye-outline</v-icon>
                    <span class="text-subtitle-1 word-break-keep">
                      <strong>Situação da Gestão: </strong>
                      <v-chip
                        :color="
                          gestao.relacaoAulasEtapas && gestao.totalPendencias === 0
                            ? 'green'
                            : 'red'
                        "
                        text-color="white"
                        class="ml-5 mb-1 status-chip"
                        :title="textoPendenciasPorGestao(gestao, false)"
                      >
                        <span v-if="gestao.relacaoAulasEtapas && gestao.totalPendencias === 0">
                          Concluída
                        </span>
                        <span v-else v-html="textoPendenciasPorGestao(gestao, true)"></span>
                      </v-chip>
                    </span>
                  </v-col>
                </v-row>
              </v-card-title>

              <v-card-text>
                <!-- Tabela para Aulas -->
                <div
                  v-if="gestao.categorias.aulas && gestao.categorias.aulas.length > 0"
                  class="categoria-tabela mb-4"
                >
                  <h5 class="text-h6 mb-2 categoria-titulo">
                    <v-icon left color="blue">mdi-school</v-icon>
                    Aulas
                  </h5>
                  <v-data-table
                    :headers="tabelaHeadersAulas"
                    :items="gestao.categorias.aulas"
                    class="elevation-1"
                    hide-default-footer
                    disable-pagination
                    :items-per-page="-1"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :color="item.status.color"
                        small
                        :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                      >
                        {{ item.status.text }}
                      </v-chip>
                    </template>
                    <template v-slot:item.disciplina="{ item }">
                      {{ item.disciplina || "N/A." }}
                    </template>
                  </v-data-table>
                </div>

                <!-- Tabela para Frequências -->
                <div
                  v-if="gestao.categorias.frequencias && gestao.categorias.frequencias.length > 0"
                  class="categoria-tabela mb-4"
                >
                  <h5 class="text-h6 mb-2 categoria-titulo">
                    <v-icon left color="orange">mdi-clipboard-check</v-icon>
                    Frequências
                  </h5>
                  <v-data-table
                    :headers="tabelaHeadersFrequencias"
                    :items="gestao.categorias.frequencias"
                    class="elevation-1"
                    hide-default-footer
                    disable-pagination
                    :items-per-page="-1"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :color="item.status.color"
                        small
                        :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                      >
                        {{ item.status.text }}
                      </v-chip>
                    </template>
                    <template v-slot:item.disciplina="{ item }">
                      {{ item.disciplina || "N/A" }}
                    </template>
                  </v-data-table>
                </div>

                <!-- Tabela para Avaliações -->
                <div
                  v-if="gestao.categorias.avaliacoes && gestao.categorias.avaliacoes.length > 0"
                  class="categoria-tabela mb-4"
                >
                  <h5 class="text-h6 mb-2 categoria-titulo">
                    <v-icon left color="purple">mdi-file-document-edit</v-icon>
                    Notas
                  </h5>
                  <div v-if="gestao.turma_polivalente">
                    <div v-for="(etapaData, i) in gestao.categorias.avaliacoes" :key="i">
                      <h6 class="text-subtitle-1 mt-4 mb-2">
                        <strong>{{ etapaData.etapa }}</strong>
                      </h6>
                      <v-data-table
                        :headers="tabelaHeadersAvaliacoesPolivalente"
                        :items="etapaData.avaliacoes"
                        class="elevation-1"
                        hide-default-footer
                        disable-pagination
                        :items-per-page="-1"
                      >
                        <template v-slot:item.status="{ item }">
                          <v-chip
                            :color="item.status.color"
                            small
                            :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                          >
                            {{ item.status.text }}
                          </v-chip>
                        </template>
                        <template v-slot:item.disciplina="{ item }">
                          {{ item.disciplina || "N/A" }}
                        </template>
                      </v-data-table>
                    </div>
                  </div>
                  <div v-else>
                    <v-data-table
                      :headers="tabelaHeadersAvaliacoesNaoPolivalente"
                      :items="gestao.categorias.avaliacoes"
                      class="elevation-1"
                      hide-default-footer
                      disable-pagination
                      :items-per-page="-1"
                    >
                      <template v-slot:item.status="{ item }">
                        <v-chip
                          :color="item.status.color"
                          small
                          :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                        >
                          {{ item.status.text }}
                        </v-chip>
                      </template>
                      <template v-slot:item.disciplina="{ item }">
                        {{ item.disciplina || "N/A" }}
                      </template>
                    </v-data-table>
                  </div>
                </div>

                <!-- Tabela para Planos -->
                <div
                  v-if="gestao.categorias.planos && gestao.categorias.planos.length > 0"
                  class="categoria-tabela mb-4"
                >
                  <h5 class="text-h6 mb-2 categoria-titulo">
                    <v-icon left color="green">mdi-notebook-edit</v-icon>
                    Planos Bimestrais
                  </h5>
                  <div v-if="gestao.turma_polivalente">
                    <div v-for="(bimestreData, i) in gestao.categorias.planos" :key="i">
                      <h6 class="text-subtitle-1 mt-4 mb-2">
                        <strong>{{ bimestreData.bimestre }}</strong>
                      </h6>
                      <v-data-table
                        :headers="tabelaHeadersPlanosPolivalente"
                        :items="bimestreData.planos"
                        class="elevation-1"
                        hide-default-footer
                        disable-pagination
                        :items-per-page="-1"
                      >
                        <template v-slot:item.status="{ item }">
                          <v-chip
                            :color="item.status.color"
                            small
                            :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                          >
                            {{ item.status.text }}
                          </v-chip>
                        </template>
                      </v-data-table>
                    </div>
                  </div>
                  <div v-else>
                    <v-data-table
                      :headers="tabelaHeadersPlanosNaoPolivalente"
                      :items="gestao.categorias.planos"
                      class="elevation-1"
                      hide-default-footer
                      disable-pagination
                      :items-per-page="-1"
                    >
                      <template v-slot:item.status="{ item }">
                        <v-chip
                          :color="item.status.color"
                          small
                          :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                        >
                          {{ item.status.text }}
                        </v-chip>
                      </template>
                    </v-data-table>
                  </div>
                </div>

                <!-- Tabela para Plano Anual -->
                <div
                  v-if="gestao.categorias.planoAnual && gestao.categorias.planoAnual.length > 0"
                  class="categoria-tabela mb-4"
                >
                  <h5 class="text-h6 mb-2 categoria-titulo">
                    <v-icon left color="teal">mdi-book-open-variant</v-icon>
                    Plano Anual
                  </h5>
                  <v-data-table
                    :headers="tabelaHeadersPlanoAnual"
                    :items="gestao.categorias.planoAnual"
                    class="elevation-1"
                    hide-default-footer
                    disable-pagination
                    :items-per-page="-1"
                  >
                    <template v-slot:item.status="{ item }">
                      <v-chip
                        :color="item.status.color"
                        small
                        :text-color="item.status.color === 'yellow' ? 'black' : 'white'"
                      >
                        {{ item.status.text }}
                      </v-chip>
                    </template>
                  </v-data-table>
                </div>

                <!-- Mensagem quando não há dados -->
                <div v-if="!temDados(gestao.categorias)" class="text-center py-4">
                  <v-icon large color="grey">mdi-information</v-icon>
                  <div class="text-subtitle-1 grey--text">
                    Nenhum dado disponível para esta gestão
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <scroll-top
        @click.native.prevent="scrollToProfessor"
        :threshold="300"
        :bottom="86"
        :right="24"
        color="primary"
        icon="mdi-arrow-up-bold"
        small
      />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "ProfessorExpansionItem",

  props: {
    professor: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      painelAberto: [0],
      isScrolled: false,
      dialogTurmas: false,
      turmasSelecionadas: [],
      turmasTemporarias: [],
      tabelaHeadersAulas: [
        { text: "Etapa", value: "etapa", sortable: true, width: "10%" },
        { text: "Lançada(s)", value: "lancado", align: "center", width: "10%" },
        { text: "Esperado", value: "esperado", align: "center", width: "10%" },
        { text: "Pendente", value: "pendente", align: "center", width: "15%" },
        { text: "Confirmada(s)", value: "confirmadas", align: "center", width: "10%" },
        {
          text: "Aguardando Confirmação",
          value: "aguardando_confirmacao",
          align: "center",
          width: "15%",
        },
        { text: "Status", value: "status", sortable: false, align: "center", width: "15%" },
      ],
      tabelaHeadersFrequencias: [
        { text: "Etapa", value: "etapa", sortable: true, width: "10%" },
        { text: "Confirmadas", value: "lancado", align: "center", width: "10%" },
        { text: "Esperado(aulas por bimestre)", value: "esperado", align: "center", width: "15%" },
        // { text: "Confirmado(a)", value: "frequencias_confirmadas", align: "center", width: "10%" },
        { text: "Pendente", value: "pendente", align: "center", width: "10%" },
        { text: "Status", value: "status", sortable: false, align: "center", width: "15%" },
      ],
      tabelaHeadersAvaliacoesPolivalente: [
        { text: "Componente Curricular", value: "disciplina", sortable: true, width: "20%" },
        // { text: "Lançado", value: "geral", align: "center", width: "10%" },
        { text: "Lançada(s)", value: "lancado", align: "center", width: "20%" },
        { text: "Esperado", value: "esperado", align: "center", width: "20%" },
        { text: "Pendente", value: "pendente", align: "center", width: "20%" },
        { text: "Status", value: "status", sortable: false, align: "center", width: "20%" },
      ],
      tabelaHeadersAvaliacoesNaoPolivalente: [
        { text: "Etapa", value: "etapa", sortable: true, width: "20%" },
        // { text: "Disciplina", value: "disciplina", sortable: true, width: "30%" },
        { text: "Lançada(s)", value: "lancado", align: "center", width: "20%" },
        { text: "Esperado", value: "esperado", align: "center", width: "20%" },
        { text: "Pendente", value: "pendente", align: "center", width: "20%" },
        { text: "Status", value: "status", sortable: false, align: "center", width: "20%" },
      ],
      tabelaHeadersPlanosPolivalente: [
        { text: "Componente Curricular", value: "disciplina", sortable: true, width: "20%" },
        // { text: "Lançado", value: "geral", align: "center", width: "10%" },
        { text: "Lançado", value: "lancado", align: "center", width: "20%" },
        { text: "Esperado", value: "esperado", align: "center", width: "20%" },
        { text: "Pendente", value: "pendente", align: "center", width: "20%" },
        { text: "Status", value: "status", sortable: false, align: "center", width: "20%" },
      ],
      tabelaHeadersPlanosNaoPolivalente: [
        { text: "Bimestre", value: "bimestre", sortable: true, width: "20%" },
        // { text: "Disciplina", value: "disciplina", sortable: true, width: "30%" },
        { text: "Lançado", value: "lancado", align: "center", width: "20%" },
        { text: "Esperado", value: "esperado", align: "center", width: "20%" },
        { text: "Pendente", value: "pendente", align: "center", width: "20%" },
        { text: "Status", value: "status", sortable: false, align: "center", width: "20%" },
      ],
      tabelaHeadersPlanoAnual: [
        { text: "Disciplina", value: "disciplina", sortable: true, width: "30%" },
        { text: "Lançado", value: "lancado", align: "center", width: "20%" },
        { text: "Esperado", value: "esperado", align: "center", width: "20%" },
        { text: "Pendente", value: "pendente", align: "center", width: "10%" },
        { text: "Status", value: "status", sortable: false, align: "center", width: "20%" },
      ],
    };
  },

  computed: {
    textoPendenciasPorGestao() {
      return (gestao) => {
        const pendenciaTypes = [];
        if (gestao.pendencias?.totais?.aulas > 0) pendenciaTypes.push("Aulas");
        if (gestao.pendencias?.totais?.frequencias > 0) pendenciaTypes.push("Frequências");
        if (gestao.pendencias?.totais?.avaliacoes > 0) pendenciaTypes.push("Notas");
        if (gestao.pendencias?.totais?.planos_bimestrais > 0)
          pendenciaTypes.push("Planos Bimestrais");
        if (gestao.pendencias?.totais?.planos_anuais > 0) pendenciaTypes.push("Plano Anual");
        if (pendenciaTypes.length === 0) {
          return "Sem pendências";
        }
        return `Pendente em: ${pendenciaTypes.join(", ")}`;
      };
    },
    itemsParaTabela() {
      if (!this.professor.gestoes) return [];

      return this.professor.gestoes.map((gestao) => {
        const totalPendenciasGestao =
          (gestao.pendencias?.totais?.aulas || 0) +
          (gestao.pendencias?.totais?.frequencias || 0) +
          (gestao.pendencias?.totais?.avaliacoes || 0) +
          (gestao.pendencias?.totais?.planos_bimestrais || 0) +
          (gestao.pendencias?.totais?.planos_anuais || 0);

        const gestaoItems = {
          turma: gestao.turma,
          turma_polivalente: gestao.is_polivalencia,
          disciplinas: gestao.disciplinas_da_gestao,
          series: gestao.series_da_turma,
          relacaoAulasEtapas: gestao.relacaoAulasEtapas,
          pendencias: gestao.pendencias,
          totalPendencias: totalPendenciasGestao,
          categorias: {
            aulas: [],
            frequencias: [],
            avaliacoes: [],
            planos: [],
            planoAnual: [],
          },
        };

        // Processar Aulas
        if (gestao.pendencias?.aulas) {
          gestaoItems.categorias.aulas = Object.entries(gestao.pendencias.aulas).map(
            ([etapa, info]) => {
              return {
                categoria: "Aulas",
                etapa,
                disciplina: "-",
                esperado: info.esperado,
                lancado: info.lancadas,
                pendente: info.pendentes,
                confirmadas: info.confirmadas,
                aguardando_confirmacao: info.aguardando_confirmacao,
                status: this.getStatus(info.lancadas, info.esperado),
              };
            }
          );
        }

        // Processar Frequências
        if (gestao.pendencias?.frequencias) {
          gestaoItems.categorias.frequencias = Object.entries(gestao.pendencias.frequencias).map(
            ([etapa, info]) => {
              return {
                categoria: "Frequências",
                etapa,
                disciplina: "-",
                esperado: info.esperado,
                lancado: info.lancadas,
                pendente: info.pendentes,
                todas_as_aulas_lancadas: info.todas_as_aulas_lancadas,
                status: this.getStatus(info.lancadas, info.esperado),
              };
            }
          );
        }

        // Processar Avaliações
        if (gestao.pendencias?.avaliacoes) {
          if (gestao.is_polivalencia) {
            // Lógica antiga para turmas POLIVALENTES
            if (gestao.curso_id === 1) {
              // Infantil
              const avaliacoesPorSemestre = {};
              Object.entries(gestao.pendencias.avaliacoes).forEach(([etapa, disciplinas]) => {
                const semestre = parseInt(etapa, 10) % 2 !== 0 ? "1º Semestre" : "2º Semestre";
                if (!avaliacoesPorSemestre[semestre]) avaliacoesPorSemestre[semestre] = {};
                Object.entries(disciplinas).forEach(([disciplina, info]) => {
                  if (!avaliacoesPorSemestre[semestre][disciplina]) {
                    avaliacoesPorSemestre[semestre][disciplina] = info;
                  }
                });
              });
              gestaoItems.categorias.avaliacoes = Object.entries(avaliacoesPorSemestre).map(
                ([semestre, disciplinas]) => ({
                  etapa: semestre,
                  avaliacoes: Object.entries(disciplinas).map(([disciplina, info]) => ({
                    disciplina,
                    esperado: info.esperado,
                    lancado: info.lancadas,
                    pendente: info.pendentes,
                    status: this.getStatus(info.lancadas, info.esperado),
                  })),
                })
              );
            } else {
              // Outros cursos
              gestaoItems.categorias.avaliacoes = Object.entries(gestao.pendencias.avaliacoes).map(
                ([etapa, disciplinas]) => ({
                  etapa,
                  avaliacoes: Object.entries(disciplinas).map(([disciplina, info]) => ({
                    disciplina,
                    esperado: info.esperado,
                    lancado: info.lancadas,
                    pendente: info.pendentes,
                    status: this.getStatus(info.lancadas, info.esperado),
                  })),
                })
              );
            }
          } else if (gestao.curso_id === 1) {
            // Lógica nova (flatMap) para turmas NÃO POLIVALENTES - Infantil
            const avaliacoesPorSemestre = {};
            Object.entries(gestao.pendencias.avaliacoes).forEach(([etapa, disciplinas]) => {
              const semestre = parseInt(etapa, 10) % 2 !== 0 ? "1º Semestre" : "2º Semestre";
              if (!avaliacoesPorSemestre[semestre]) avaliacoesPorSemestre[semestre] = {};
              Object.entries(disciplinas).forEach(([disciplina, info]) => {
                if (!avaliacoesPorSemestre[semestre][disciplina]) {
                  avaliacoesPorSemestre[semestre][disciplina] = info;
                }
              });
            });
            gestaoItems.categorias.avaliacoes = Object.entries(avaliacoesPorSemestre).flatMap(
              ([semestre, disciplinas]) =>
                Object.entries(disciplinas).map(([disciplina, info]) => ({
                  etapa: semestre,
                  disciplina,
                  esperado: info.esperado,
                  lancado: info.lancadas,
                  pendente: info.pendentes,
                  status: this.getStatus(info.lancadas, info.esperado),
                }))
            );
          } else {
            // Outros cursos
            gestaoItems.categorias.avaliacoes = Object.entries(
              gestao.pendencias.avaliacoes
            ).flatMap(([etapa, disciplinas]) =>
              Object.entries(disciplinas).map(([disciplina, info]) => ({
                etapa,
                disciplina,
                esperado: info.esperado,
                lancado: info.lancadas,
                pendente: info.pendentes,
                status: this.getStatus(info.lancadas, info.esperado),
              }))
            );
          }
        }

        // Processar Planos
        if (gestao.pendencias?.planos_bimestrais) {
          if (gestao.is_polivalencia) {
            // Lógica antiga para turmas POLIVALENTES
            gestaoItems.categorias.planos = Object.entries(gestao.pendencias.planos_bimestrais).map(
              ([bimestre, disciplinas]) => {
                return {
                  bimestre,
                  planos: Object.entries(disciplinas).map(([disciplina, info]) => {
                    return {
                      disciplina,
                      esperado: 1,
                      lancado: info.tem_plano ? 1 : 0,
                      pendente: info.tem_pendencia ? 1 : 0,
                      status: this.getStatus(info.tem_plano ? 1 : 0, 1),
                    };
                  }),
                };
              }
            );
          } else {
            // Lógica nova (flatMap) para turmas NÃO POLIVALENTES
            gestaoItems.categorias.planos = Object.entries(
              gestao.pendencias.planos_bimestrais
            ).flatMap(([bimestre, disciplinas]) =>
              Object.entries(disciplinas).map(([disciplina, info]) => ({
                bimestre,
                disciplina,
                esperado: 1,
                lancado: info.tem_plano ? 1 : 0,
                pendente: info.tem_pendencia ? 1 : 0,
                status: this.getStatus(info.tem_plano ? 1 : 0, 1),
              }))
            );
          }
        }

        // Processar Plano Anual
        if (gestao.pendencias?.planos_anuais) {
          const info = gestao.pendencias.planos_anuais;
          gestaoItems.categorias.planoAnual = [
            {
              disciplina: info.disciplina_descricao || "-",
              esperado: 1,
              lancado: info.tem_plano ? 1 : 0,
              pendente: info.tem_pendencia ? 1 : 0,
              status: this.getStatus(info.tem_plano ? 1 : 0, 1),
            },
          ];
        }

        return gestaoItems;
      });
    },

    iniciais() {
      if (!this.professor.nome) return "N/A";
      const nomes = this.professor.nome.split(" ");
      if (nomes.length === 1) {
        return nomes[0].substring(0, 2).toUpperCase();
      }
      return (nomes[0][0] + nomes[nomes.length - 1][0]).toUpperCase();
    },

    totalGestoes() {
      return this.professor.gestoes?.length || 0;
    },

    totalPendenciasAulas() {
      if (!this.professor.gestoes) return 0;
      return this.professor.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.aulas || 0);
      }, 0);
    },

    totalPendenciasFrequencias() {
      if (!this.professor.gestoes) return 0;
      return this.professor.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.frequencias || 0);
      }, 0);
    },

    totalPendenciasAvaliacoes() {
      if (!this.professor.gestoes) return 0;
      return this.professor.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.avaliacoes || 0);
      }, 0);
    },

    totalPendenciasPlanos() {
      if (!this.professor.gestoes) return 0;
      return this.professor.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.planos_bimestrais || 0);
      }, 0);
    },

    totalPendenciasPlanoAnual() {
      if (!this.professor.gestoes) return 0;
      return this.professor.gestoes.reduce((total, gestao) => {
        return total + (gestao.pendencias?.totais?.planos_anuais || 0);
      }, 0);
    },

    /**
     * Calcula o desempenho geral do professor com base no total de itens concluídos em relação ao total de itens esperados em todas as suas gestões.
     * O cálculo considera quatro categorias principais:
     *
     * 1.  **Aulas:** Compara o número de aulas 'lançadas' com o número de aulas 'esperadas'.
     * 2.  **Frequências:** Compara o número de frequências 'lançadas' com o número 'esperado' de registros de frequência.
     * 3.  **Avaliações:** Compara o número de avaliações 'lançadas' com o número 'esperado'.
     * 4.  **Planos Bimestrais:** Verifica se um plano foi entregue (concluído) para cada um esperado.
     *
     * O resultado final é uma porcentagem que representa a proporção de itens concluídos em relação ao total esperado.
     */
    desempenhoGeralPercentual() {
      if (!this.professor.gestoes) return 0;

      const { totalEsperado, totalConcluido } = this.professor.gestoes.reduce(
        (acc, gestao) => {
          if (!gestao.pendencias) return acc;

          if (gestao.pendencias.aulas) {
            Object.values(gestao.pendencias.aulas).forEach((dados) => {
              const esperado = dados.esperado || 0;
              const lancado = dados.lancadas || 0;
              acc.totalEsperado += esperado;
              acc.totalConcluido += Math.min(lancado, esperado);
            });
          }

          if (gestao.pendencias.frequencias) {
            Object.values(gestao.pendencias.frequencias).forEach((dados) => {
              const esperado = dados.esperado || 0;
              const lancado = dados.lancadas || 0;
              acc.totalEsperado += esperado;
              acc.totalConcluido += Math.min(lancado, esperado);
            });
          }

          if (gestao.pendencias.avaliacoes) {
            if (gestao.is_polivalencia) {
              Object.values(gestao.pendencias.avaliacoes).forEach((disciplinas) => {
                Object.values(disciplinas || {}).forEach((dados) => {
                  const esperado = dados.esperado || 0;
                  const lancado = dados.lancadas || 0;
                  acc.totalEsperado += esperado;
                  acc.totalConcluido += Math.min(lancado, esperado);
                });
              });
            } else {
              Object.values(gestao.pendencias.avaliacoes).forEach((disciplinas) => {
                Object.values(disciplinas || {}).forEach((dados) => {
                  const esperado = dados.esperado || 0;
                  const lancado = dados.lancadas || 0;
                  acc.totalEsperado += esperado;
                  acc.totalConcluido += Math.min(lancado, esperado);
                });
              });
            }
          }

          if (gestao.pendencias.planos_bimestrais) {
            if (gestao.is_polivalencia) {
              Object.values(gestao.pendencias.planos_bimestrais).forEach((disciplinas) => {
                Object.values(disciplinas || {}).forEach((dados) => {
                  acc.totalEsperado += 1;
                  if (dados.tem_plano) {
                    acc.totalConcluido += 1;
                  }
                });
              });
            } else {
              Object.values(gestao.pendencias.planos_bimestrais).forEach((disciplinas) => {
                Object.values(disciplinas || {}).forEach((dados) => {
                  acc.totalEsperado += 1;
                  if (dados.tem_plano) {
                    acc.totalConcluido += 1;
                  }
                });
              });
            }
          }

          if (gestao.pendencias.planos_anuais) {
            acc.totalEsperado += 1;
            if (gestao.pendencias.planos_anuais.tem_plano) {
              acc.totalConcluido += 1;
            }
          }

          return acc;
        },
        { totalEsperado: 0, totalConcluido: 0 }
      );

      if (totalEsperado === 0) return 0;
      return Math.round((totalConcluido / totalEsperado) * 100);
    },

    desempenhoGeralColor() {
      return this.desempenhoGeralPercentual > 70 ? "green" : "red";
    },

    statusColor() {
      let tiposPendencias = 0;
      if (this.totalPendenciasAulas > 0) tiposPendencias += 1;
      if (this.totalPendenciasFrequencias > 0) tiposPendencias += 1;
      if (this.totalPendenciasAvaliacoes > 0) tiposPendencias += 1;
      if (this.totalPendenciasPlanos > 0) tiposPendencias += 1;
      if (this.totalPendenciasPlanoAnual > 0) tiposPendencias += 1;
      switch (tiposPendencias) {
        case 0:
          return "green";
        case 1:
          return "warning";
        case 2:
          return "orange";
        case 3:
          return "error";
        default:
          return "error";
      }
    },
  },

  methods: {
    scrollToProfessor() {
      this.$el.scrollIntoView({ behavior: "smooth" });
    },

    abrirDialogTurmas() {
      this.turmasTemporarias = [...this.turmasSelecionadas];
      this.dialogTurmas = true;
    },

    cancelarDialog() {
      this.dialogTurmas = false;
    },

    salvarTurmas() {
      this.turmasSelecionadas = [...this.turmasTemporarias];
      this.dialogTurmas = false;
    },

    getStatus(lancado, esperado) {
      // if (esperado <= 0) return { color: "grey", text: "Sem 'Esperado' Definido" };
      if (lancado > 0 && lancado >= esperado) return { color: "green", text: "Completo" };
      if (lancado > 0 && lancado < esperado) return { color: "yellow", text: "Incompleto" };
      if (lancado === 0) return { color: "red", text: "Nenhum Lançamento" };
      return { color: "grey", text: "Indefinido" };
    },

    temDados(categorias) {
      return Object.values(categorias).some((array) => array.length > 0);
    },

    handleScroll() {
      const expansionContent = this.$el.querySelector(".v-expansion-panel-content");
      if (expansionContent) {
        this.isScrolled = expansionContent.scrollTop > 50;
      }
    },
  },

  mounted() {
    // Adicionar listener de scroll ao conteúdo expandido
    const expansionContent = this.$el.querySelector(".v-expansion-panel-content");
    if (expansionContent) {
      expansionContent.addEventListener("scroll", this.handleScroll);
    }
  },

  beforeDestroy() {
    // Remover listener para evitar memory leaks
    const expansionContent = this.$el.querySelector(".v-expansion-panel-content");
    if (expansionContent) {
      expansionContent.removeEventListener("scroll", this.handleScroll);
    }
  },
};
</script>

<style scoped>
.professor-info {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
}

.professor-avatar {
  flex-shrink: 0;
}

.gestao-card {
  border-left: 4px solid #4caf50;
  /* green  */
  transition: all 0.3s ease;
}

.zebra-even {
  background-color: #ffffff !important;
}

.zebra-odd {
  background-color: #f5f5f5 !important;
}

.gestoes-container {
  padding: 0 8px;
  position: relative;
}

.word-break-keep {
  word-break: keep-all;
}

.categoria-tabela {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  background-color: #fafafa;
}

.categoria-titulo {
  color: #424242;
  border-bottom: 2px solid;
  padding-bottom: 8px;
}

.categoria-titulo .v-icon {
  margin-right: 8px;
}

/* Estilos para a legenda fixa */
.legenda-fixa {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: white;
  padding: 8px 0;
  margin-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.legenda-rolagem {
  background-color: #f5f5f5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 12px 0;
}

.legenda-content {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

/* Ajuste para garantir que o conteúdo não fique atrás da legenda fixa */
.gestoes-container > .text-h6 {
  margin-top: 16px;
}

/* Responsividade */
@media (max-width: 600px) {
  .professor-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .professor-info .v-chip {
    align-self: flex-end;
  }

  .categoria-tabela {
    padding: 8px;
  }

  .legenda-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .legenda-content .text-caption {
    margin-bottom: 8px;
  }
}

.status-chip {
  height: auto !important;
  min-height: 42px;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  line-height: 1.3;
  text-align: center;
  white-space: normal;
}
</style>
